/**
 * Bandas de prioridad de los anuncios del cintillo.
 *
 * El número decide el orden entre todas las fuentes (menor = primero).
 *
 * Integración con backoffice:
 *   - priority < 100 para fijar por encima de las alertas de onboarding
 *     (incidentes críticos, avisos de fraude).
 *   - priority 200-299 para informativos post-onboarding.
 *   - priority 300+ para promos o avisos de baja urgencia.
 *
 * Este archivo tenía además un modelo propio de estado de onboarding
 * (`UserOnboardingStatus`, `getOnboardingAlerts`, `validateUserCanOperate`) que
 * derivaba a mano lo que `/api/v1/me` ya responde en `account_provisioning`.
 * Se eliminó: tenía `hasSignature` y `pagacelAssigned` fijos en `true` —dos
 * alertas inalcanzables— y un copy que prometía "la activación de tu cuenta
 * CLABE tarda entre 10 min y hasta 1 hora" a usuarios que no habían solicitado
 * ninguna. Ver `useOnboardingAnnouncements`.
 */
export const ANNOUNCEMENT_PRIORITY = {
  /** System / BE emergency — always floats above everything else. */
  SYSTEM_CRITICAL: 10,
  /** Onboarding gates — user cannot operate without resolving these. */
  ONBOARDING_KYC: 100,
  ONBOARDING_CLABE: 110,
  ONBOARDING_SIGNATURE: 120,
  ONBOARDING_PAGACEL: 130,
  /** Backoffice informational — appears below onboarding requirements. */
  BACKOFFICE_HIGH: 200,
  /** Promos, feature announcements — lowest urgency. */
  BACKOFFICE_LOW: 300,
} as const;
